<style scoped>
.header-div {
  font-size: 14px;
  color: var(--color-text-dark);
  font-weight: bold;
  /*margin-bottom: 20px;*/
}
.pnl-chart-box {
  height: 500px;
}
.empty-data-desc {
  font-size: 20px;
  color: var(--color-neutral);
}
.empty-data-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
div {
  /*border: 1px solid pink;*/
}
</style>

<template>
  <div class="pnl-chart-box box symbbox">
    <div class="header-div">{{ $text.tr('ПРИБЫЛЬ') }}, $</div>
    <div v-if="!this.statsdata.TotalPNLByDay.Labels || this.statsdata.TotalPNLByDay.Labels.length < 2" class="empty-data-box">
      <img src="../../../assets/monitor.png" width="300px"><br>
      <div class="empty-data-desc">{{ $text.tr('Нет данных') }}</div>
    </div>
    <LineChart v-else :chart-data="lineChartData" :options="lineChartOptions"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import LineChart from '@/components/MainPage/Portfolio/LineChart.vue'
import { StatsData } from '@/util/types'

@Component({
  components: {
    LineChart
  }
})
export default class TotalPNLByDayLineChart extends Vue {
  lineChartData = {
    labels: [''],
    datasets: [
      {
        borderColor: '#20b2aa',
        pointBackgroundColor: '#20b2aa',
        borderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 5,
        pointBorderColor: '#20b2aa',
        backgroundColor: 'transparent',
        data: ['0'],
        lineTension: 0
      }
    ]
  }

  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    animation: false,
    scales: {
      yAxes: [{
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'right',
        // id: 'y-axis-usd',
        // gridLines: {
        //   drawOnChartArea: false // only want the grid lines for one axis to show up
        // },
        ticks: {
          fontColor: '#6b74e7' // this here
        }
      }],
      xAxes: [{
        gridLines: {
          drawOnChartArea: false // only want the grid lines for one axis to show up
        }
      }]
    }
  }

  get statsdata () {
    // @ts-ignore
    return (this.$store.state.stats as StatsData)
  }

  @Watch('statsdata')
  statsDataChanged () {
    this.updateLineChart()
  }

  created () {
    this.updateLineChart()
  }

  updateLineChart () {
    // console.log('updateLineChart', this.statsdata.TotalPNLByDay.Labels, this.statsdata.TotalPNLByDay.Values)
    if (this.statsdata.TotalPNLByDay.Values) {
      this.lineChartData.labels = this.statsdata.TotalPNLByDay.Labels
      this.lineChartData.datasets[0].data = this.statsdata.TotalPNLByDay.Values
      // this.lineChartData.datasets[0].backgroundColor = this.statsdata.TotalPNLByDay.Values.map((value) => parseFloat(value) < 0 ? '--color-danger-light' : 'var(--color-success-light)')
    }
  }
}
</script>
